 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-login-login-module-ngfactory":"pages-login-login-module-ngfactory","pages-profile-profile-module-ngfactory":"pages-profile-profile-module-ngfactory","pages-settings-settings-module-ngfactory":"pages-settings-settings-module-ngfactory","default~pages-city-list-city-list-module-ngfactory~pages-detail-detail-module-ngfactory~pages-events~b4644d6b":"default~pages-city-list-city-list-module-ngfactory~pages-detail-detail-module-ngfactory~pages-events~b4644d6b","pages-city-list-city-list-module-ngfactory":"pages-city-list-city-list-module-ngfactory","pages-generic-content-generic-content-module-ngfactory":"pages-generic-content-generic-content-module-ngfactory","pages-itinerary-list-itinerary-list-module-ngfactory":"pages-itinerary-list-itinerary-list-module-ngfactory","default~pages-detail-detail-module-ngfactory~pages-events-events-module-ngfactory~pages-home-home-mo~5e6bff22":"default~pages-detail-detail-module-ngfactory~pages-events-events-module-ngfactory~pages-home-home-mo~5e6bff22","default~pages-detail-detail-module-ngfactory~pages-last-minute-detail-last-minute-detail-module-ngfa~74dcc72f":"default~pages-detail-detail-module-ngfactory~pages-last-minute-detail-last-minute-detail-module-ngfa~74dcc72f","pages-detail-detail-module-ngfactory":"pages-detail-detail-module-ngfactory","pages-maps-search-maps-search-module-ngfactory":"pages-maps-search-maps-search-module-ngfactory","default~pages-events-events-module-ngfactory~pages-favourites-list-favourites-list-module-ngfactory~~ac7c5d3e":"default~pages-events-events-module-ngfactory~pages-favourites-list-favourites-list-module-ngfactory~~ac7c5d3e","pages-favourites-list-favourites-list-module-ngfactory":"pages-favourites-list-favourites-list-module-ngfactory","pages-last-minute-last-minute-module-ngfactory":"pages-last-minute-last-minute-module-ngfactory","pages-events-events-module-ngfactory":"pages-events-events-module-ngfactory","pages-home-home-module-ngfactory":"pages-home-home-module-ngfactory","pages-itineraries-list-itineraries-list-module-ngfactory":"pages-itineraries-list-itineraries-list-module-ngfactory","pages-pois-list-pois-list-module-ngfactory":"pages-pois-list-pois-list-module-ngfactory","pages-last-minute-detail-last-minute-detail-module-ngfactory":"pages-last-minute-detail-last-minute-detail-module-ngfactory","pages-callback-callback-module-ngfactory":"pages-callback-callback-module-ngfactory","pages-cards-cards-module-ngfactory":"pages-cards-cards-module-ngfactory","pages-content-content-module-ngfactory":"pages-content-content-module-ngfactory","pages-list-list-module-ngfactory":"pages-list-list-module-ngfactory","pages-list-master-list-master-module-ngfactory":"pages-list-master-list-master-module-ngfactory","pages-logout-logout-module-ngfactory":"pages-logout-logout-module-ngfactory","pages-page-not-found-page-not-found-module-ngfactory":"pages-page-not-found-page-not-found-module-ngfactory","pages-search-search-module-ngfactory":"pages-search-search-module-ngfactory","pages-signup-signup-module-ngfactory":"pages-signup-signup-module-ngfactory","pages-tutorial-tutorial-module-ngfactory":"pages-tutorial-tutorial-module-ngfactory","pages-welcome-welcome-module-ngfactory":"pages-welcome-welcome-module-ngfactory"}[chunkId]||chunkId) + "." + {"0":"86b9fc66bc1986204922","1":"7cc6854122fc11f0697a","2":"c442cdaf14628467a826","3":"476e6a5467c52c65aedc","4":"67baabe8fcaa9669faa1","5":"6d2f9cf681b98fb68ebe","6":"329e634f30bf5728277f","7":"c6a5146e0d62507ba099","8":"f9a3d429bc568342deaa","9":"94c8bd88b06f8a07b466","10":"b6dcc029a3cfe132d915","11":"323f152bef5ff6587692","12":"cfae6b81a6bdf54a2b29","13":"c4f0046b4d6d4cea5077","14":"10130f57e488297d7968","15":"6ba88e58694a92d03bb5","16":"0452361d7c223a375b6a","17":"275c5330b3ea9c643080","18":"1ce7a1dd1e8528b91e8f","19":"a65b1515c898299b5af5","20":"ea388f0784bcbbb64f5c","21":"8e33a8204af41d37e73e","22":"5cb8a2670b67a5a56452","23":"47369c2ab043837e4b26","24":"95e4540a4536aba2b204","25":"a8f211d039561c2392ed","26":"5226d0bc905e9333c49e","27":"d7972754bec30c114066","28":"86a93cfe422e19a8de78","29":"57f508f51fa98c43ec53","30":"cda6338935e2e3996a38","31":"6c3cb6fb405066ed03a5","32":"7a8fb106e42077817039","33":"0287fc367d1a99a917d1","34":"06dfa8f3b829923c33bb","35":"c6c4339416d159a70ec3","36":"8be62ef4f34c16c56e0f","37":"f27eb2bf9e05fcb0cfc8","38":"f12070222b3803042584","39":"05620f83934531ccaf8b","40":"cd524578554e208a0aa1","41":"b1285d57df79d6d5435b","42":"a011beb472716f3d999c","43":"73ab01b2cf4eb885a75e","44":"ca9f509906b9a9293a0e","45":"44971256d012590039c3","46":"c00228361d2e76df1c54","47":"7476f38431c8ca095d8d","48":"bcf629f219fc1cfcea40","49":"d2e5331a1e1dafe96e36","50":"770bd2f9d4a5a3fb0c42","51":"36c23de332a4e3936680","52":"9fa010850ad5f54a6d79","53":"d7e997838238cff03760","54":"68ccf40e830fbaeca124","55":"eb1326ee49bac23ee3ed","56":"b113dc8de34a51f2d417","57":"34ad8923ec041a3425a1","58":"cc91ac12dbb62b565653","59":"3627c2854d16fae412c3","60":"63bd48bcc6fa46ee5e9c","61":"6363190bb470f9a571a7","62":"1133e0579d9bd0deb1cf","63":"b46a017554661174fcfe","64":"f40461b8469a6255b793","65":"b75246045d26a2e012bb","66":"9b5d9c3572cd3002e6c8","67":"8ad4d9231a0944bf471b","68":"a7cb1ae4d72eeef26028","69":"ae506bef7de3cfe8137a","70":"68e26a2f1b5e457df7d2","71":"2d8c4338785edf0ac289","72":"2b4fd7ec80fa89e37a1a","73":"d4a7667110fdb063d2ed","74":"1a25002a1ea38b18508b","75":"c169c347b720cd89c35f","76":"a695657c7e8dfca8af78","77":"31fed8e9506fd6ab29cf","78":"8e5d6b9fa5e30e6af131","79":"3b351b061b7a956c4f06","80":"74b5a6f81f6c92f991bc","81":"a2bc023e7adc5dc7c40f","82":"e5c0b367830ffa570e04","83":"ea133429aa85a792ccaf","84":"6522fdaba018abd3399a","85":"31ab76e1a28a4469f91c","86":"09294542236016d519f4","87":"d7382742f6639e046595","88":"3b6aa7cb7cc28d0b1cd9","89":"547efa7ee62f8d09e8c2","90":"2581ffc4308721e67c13","91":"9b4e853795b9b0ea5743","92":"5c1cfc6c6c38ee66eb30","93":"ba81e7717577f1f9994f","common":"23a1fdf0799a03c5fcac","pages-login-login-module-ngfactory":"a6003c23e80b6b2bfda9","pages-profile-profile-module-ngfactory":"d063cb8c5d9c9e6d6fc3","pages-settings-settings-module-ngfactory":"e8834c7faad05ee36603","default~pages-city-list-city-list-module-ngfactory~pages-detail-detail-module-ngfactory~pages-events~b4644d6b":"917100c7e503b9b57448","pages-city-list-city-list-module-ngfactory":"ad5af48d01bba4f784a8","pages-generic-content-generic-content-module-ngfactory":"d7be07a5a83c2f25058a","pages-itinerary-list-itinerary-list-module-ngfactory":"937fb388f9bcfe5ce190","default~pages-detail-detail-module-ngfactory~pages-events-events-module-ngfactory~pages-home-home-mo~5e6bff22":"ea3a5852140bc2ed5990","default~pages-detail-detail-module-ngfactory~pages-last-minute-detail-last-minute-detail-module-ngfa~74dcc72f":"a331976ea09e25e3e95e","pages-detail-detail-module-ngfactory":"53aa4de323e9f78d1c41","pages-maps-search-maps-search-module-ngfactory":"c124326e453589530928","default~pages-events-events-module-ngfactory~pages-favourites-list-favourites-list-module-ngfactory~~ac7c5d3e":"c09fb65fef28057c09ea","pages-favourites-list-favourites-list-module-ngfactory":"c6282b30afd350f35b3d","pages-last-minute-last-minute-module-ngfactory":"25d1c75068e2af2e1bbf","pages-events-events-module-ngfactory":"edd911489ead68bcd57f","pages-home-home-module-ngfactory":"1894ea50e319b5694c4c","pages-itineraries-list-itineraries-list-module-ngfactory":"4506866e38b13a5e2b1f","pages-pois-list-pois-list-module-ngfactory":"812f27032b6bb55553df","pages-last-minute-detail-last-minute-detail-module-ngfactory":"671bc49bb7a00e3b00e8","pages-callback-callback-module-ngfactory":"17f176ba8d7db139c5dc","pages-cards-cards-module-ngfactory":"cef93dceea7068f7ad84","pages-content-content-module-ngfactory":"2c688a153823365b4561","pages-list-list-module-ngfactory":"95366ab8e1a59d76995e","pages-list-master-list-master-module-ngfactory":"48079b1240b6c14cc2b8","pages-logout-logout-module-ngfactory":"4835d658b1b054b2b89e","pages-page-not-found-page-not-found-module-ngfactory":"45ae89f6ef9cb9ea9391","pages-search-search-module-ngfactory":"a8f2f6a01edd8ce933a9","pages-signup-signup-module-ngfactory":"523ce4c602171978fff6","pages-tutorial-tutorial-module-ngfactory":"0d38f3cf3e7d7c1805d2","pages-welcome-welcome-module-ngfactory":"0cf42cc28641b9a9db97"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
